import { ElementBuilder } from "@universityofmaryland/web-builder-library";
import * as token from "@universityofmaryland/web-token-library";
import * as typography from "@universityofmaryland/web-styles-library/typography";
import { theme } from "@universityofmaryland/web-utilities-library/theme";
import { createCompositeQuoteAction } from "./action.js";
import { createCompositeQuote } from "./quote.js";
import { SMALL } from "../_constants.js";
const createChildren = (props) => {
  const {
    action,
    attribution,
    attributionSubText,
    hasImage,
    includesAnimation,
    isThemeDark,
    isSizeLarge,
    quote,
    shouldHaveWhiteText
  } = props;
  const wrapperChildren = [];
  if (quote) {
    wrapperChildren.push(
      createCompositeQuote({
        ...props,
        shouldHaveWhiteText,
        quote,
        hasImage,
        isSizeLarge
      })
    );
  }
  if (attribution) {
    const attributionElement = new ElementBuilder(attribution).styled(
      typography.sans.compose("medium", {
        theme: theme.fontColor(shouldHaveWhiteText)
      })
    ).withClassName("quote-container-attribution").withStyles({
      element: {
        marginTop: token.spacing.sm,
        ...includesAnimation && {
          opacity: "0",
          transform: "translateY(20px)",
          transition: "opacity 1s ease, transform 0.5s ease"
        },
        ...!shouldHaveWhiteText && {
          color: token.color.gray.dark
        },
        [`& *`]: {
          color: "currentColor"
        }
      }
    }).build();
    wrapperChildren.push(attributionElement);
  }
  if (attributionSubText) {
    const attributionSubTextElement = new ElementBuilder(attributionSubText).styled(typography.sans.small).withClassName("quote-container-text-attribution-sub-text").withStyles({
      element: {
        color: token.color.gray.dark,
        fontStyle: "italic",
        ...includesAnimation && {
          opacity: "0",
          transform: "translateY(20px)",
          transition: "opacity 1s ease, transform 0.5s ease"
        },
        ...shouldHaveWhiteText && {
          color: token.color.white
        }
      }
    }).build();
    wrapperChildren.push(attributionSubTextElement);
  }
  if (action) {
    const actionElement = createCompositeQuoteAction({
      ...props,
      action
    });
    wrapperChildren.push(actionElement);
  }
  return wrapperChildren;
};
const CreateStatementQuoteHeadline = ({
  headline
}) => {
  if (!headline) return null;
  return new ElementBuilder(headline).withClassName("statement-headline").withStyles({
    element: {
      color: token.color.black,
      fontSize: token.font.size.base,
      textTransform: "uppercase",
      marginBottom: token.spacing.sm,
      letterSpacing: "2px",
      fontWeight: token.font.weight.light
    }
  }).build();
};
const CreateStatementQuoteAttribution = ({
  attribution,
  attributionSubText
}) => {
  if (!attribution && !attributionSubText) return null;
  const container = new ElementBuilder().withClassName("statement-attribution-container").withStyles({
    element: {
      margin: token.spacing.lg
    }
  });
  if (attribution) {
    const attributionElement = new ElementBuilder(attribution).withClassName("statement-attribution").withStyles({
      element: {
        fontWeight: token.font.weight.bold,
        color: token.color.black,
        fontSize: token.font.size.xl,
        marginBottom: token.spacing.xs
      }
    }).build();
    container.withChild(attributionElement);
  }
  if (attributionSubText) {
    const subTextElement = new ElementBuilder(attributionSubText).withClassName("statement-attribution-subtext").withStyles({
      element: {
        color: token.color.gray.dark,
        fontSize: token.font.size.sm
      }
    }).build();
    container.withChild(subTextElement);
  }
  return container.build();
};
const CreateQuoteTextElement = (props) => {
  const {
    image,
    isSizeLarge = false,
    isThemeDark,
    isThemeMaryland,
    isTypeFeatured = false
  } = props;
  const shouldHaveWhiteText = isThemeDark || isThemeMaryland;
  const isSizeLargeAndNotFeatured = isSizeLarge && !isTypeFeatured;
  const hasImage = image != null;
  const isHasImageAndNotFeatured = hasImage && !isTypeFeatured;
  const children = createChildren({
    ...props,
    shouldHaveWhiteText,
    hasImage
  });
  const wrapper = new ElementBuilder().withClassName("quote-text-container-wrapper").withChildren(...children).build();
  return new ElementBuilder().withClassName("quote-text-container").withChild(wrapper).withStyles({
    element: {
      width: "100%",
      [`@container (max-width: ${SMALL - 1}px)`]: {
        paddingLeft: token.spacing.md,
        ...!hasImage && {
          paddingTop: token.spacing.lg
        },
        ...isSizeLargeAndNotFeatured && {
          paddingTop: token.spacing["2xl"]
        }
      },
      [`@container (min-width: ${SMALL}px)`]: {
        paddingLeft: token.spacing["4xl"],
        ...isHasImageAndNotFeatured && { paddingLeft: "0" }
      }
    }
  }).build();
};
const createCompositeQuoteText = CreateQuoteTextElement;
const createStatementQuoteHeadline = CreateStatementQuoteHeadline;
const createStatementQuoteAttribution = CreateStatementQuoteAttribution;
export {
  createCompositeQuoteText,
  createStatementQuoteAttribution,
  createStatementQuoteHeadline
};
//# sourceMappingURL=text.js.map
